import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Select from 'react-select';
import {baseUrl, issueStatusList, requirementStatusList,orderStatusList,purchaseStatusList,receiptStatusList, addDays } from "../../comman/config";
import { menuAboveTable } from "../../comman/selectMenu";

const VegRequirementFilter = ({ handleFilterChange, page, handleClearFilters }) => {
    const today = addDays(new Date(), 2).toISOString().split('T')[0];
    const [fromDate, setFromDate] = useState(addDays(new Date(), 2).toISOString().split('T')[0]);
    const [toDate, setToDate] = useState(addDays(new Date(), 2).toISOString().split('T')[0]);
    const [session, setSession] = useState([]);
    
    const [requirementStatus, setRequirementStatus] = useState(requirementStatusList[1]);
    const [orderStatus, setOrderStatus] = useState(orderStatusList[1]);
    const [purchaseStatus, setPurchaseStatus] = useState(purchaseStatusList[1]);
    const [receiptStatus, setReceiptStatus] = useState([receiptStatusList[1],receiptStatusList[2]]);
    const [issueStatus, setIssueStatus] = useState([issueStatusList[1], issueStatusList[2]])
    const [orderId, setOrderId] = useState("");
    const [ingredientList, setIngredientList] = useState([]);
    const [filter, setFilter] = useState(false);
    const [sessionList, setSessionList] = useState([]);
    const [orderIdList, setOrderIdList] = useState([]);
    const [itemList, setItemList] = useState([]);
    const [item, setItem] = useState([]);
    const [ingredient, setIngredient] = useState([]);
    const [eventList, setEventList] = useState([]);
    const [event, setEvent] = useState({});
    

    useEffect(() => {
        getSessionList();
        getItemList();
        getIngredientList();
        getOrderIdList();
        getEventList();
    }, []);

    const getSessionList =  async () => {
        const response = await axios.get(`${baseUrl}/comman/list?table=session_master&condition=status=1`,
            { headers: { 'Cache-Control': 'no-cache' } }
        );
        setSessionList(response.data.data);
    }

    const getItemList = async () => {
        const response = await axios.get(`${baseUrl}/comman/list?table=item_master&condition=status=1`);
        const itemList = response.data.data;
        setItemList(itemList);
    }

    const getIngredientList = async () => {
        const response = await axios.get(`${baseUrl}/ingredients/list?limit=all`);
        const list = response.data.data.filter((item) => item.status == 1 && item?.store?.id == 3);
        setIngredientList(list);
    };

    const getEventList = async () => {
        const response = await axios.get(`${baseUrl}/comman/list?table=event_master&condition=status=1`);
        const data = response.data.data;
        setEventList(data);
        setEvent({ value: 'all', label: 'All' });
    }

    const getOrderIdList =  async () => {
        const condition = `order_id IS NOT NULL GROUP BY order_id`;
        const response = await axios.get(`${baseUrl}/comman/list?table=item_requirement_summary&condition=${condition}`,
            { headers: { 'Cache-Control': 'no-cache' } }
        );
        setOrderIdList(response.data.data);
    }
    const handleDateChange = (e) => {
        const {name, value} = e.target;
        if(name == "from_date"){
            setFromDate(value);
        }else if(name == "to_date"){
            setToDate(value);
        }
    };

    
    const handleSelectChange = (data, option) => {
        if(option.name == 'session'){
            setSession(data);
        }else if(option.name == 'requirement_status'){
            setRequirementStatus(data);
        }else if(option.name == 'order_status'){
            setOrderStatus(data);
        }else if(option.name == 'order_id'){
            setOrderId(data);
        }else if(option.name == 'purchase_status'){
            setPurchaseStatus(data);
        }else if(option.name == 'receipt_status'){
            setReceiptStatus(data);
        }else if(option.name == 'issue_status'){
            setIssueStatus(data)
        }
        
    };
    const handleChangeMultiSelect = (selected, name) => {
        if(name === 'item'){
            setItem(selected);
        }else if(name === "ingredient"){
            setIngredient(selected);
        }
        
    };

    const handelEventChange = (selectedEvent) => {
        const data = eventList.filter(i => i.id == selectedEvent.value);
        setEvent({value: data[0].id, label: data[0].event_name});
        
            // For specific events, use that event's dates
            setFromDate(data[0].start_date);
            setToDate(data[0].end_date);
            setIngredient({ value: 'all', label: 'All' });
            setSession({ value: 'all', label: 'All' });
            handleFilterChange(
                data[0].start_date, 
                data[0].end_date, 
                { value: 'all', label: 'All' }, 
                { value: 'all', label: 'All' }, 
                {value: data[0].id, label: data[0].event_name}, 
                true
            );
        
        
        setFilter(true);
    };

    const handleSubmit = () => {
        // console.log(ingredient, issueStatus);
        handleFilterChange(fromDate, toDate, session, item, requirementStatus, orderStatus, orderId, purchaseStatus, receiptStatus,issueStatus, ingredient);
        setFilter(true);
    };

    const handleClear = () => {
        // Clear takes the inline per-column filters with it. Leaving them set would look like
        // Clear had emptied the report, when a column filter is still hiding the rows.
        handleClearFilters?.();
        setSession([]);
        setEvent({ value: 'all', label: 'All' })
        setFromDate(today);
        setToDate(today);
        setItem([]);
        setRequirementStatus(requirementStatusList[1]);
        setOrderStatus(orderStatusList[1]);
        setPurchaseStatus(purchaseStatusList[1]);
        setReceiptStatus([receiptStatusList[1], receiptStatusList[2]]);
        setIssueStatus([issueStatusList[1], issueStatusList[2]])
        setOrderId("");
        setIngredient([]);
        handleFilterChange(today, today, [], [], requirementStatusList[1],orderStatusList[1],"",purchaseStatusList[1],[receiptStatusList[1], receiptStatusList[2]],[issueStatusList[1], issueStatusList[2]], []);
        setFilter(false);
    }

    return (
        <div className="pb-4 flex flex-column max-sm:flex-row flex-wrap space-y-4 sm:space-y-0 items-center">
            {page == "stock_report" &&
            <>
            <div className='m-5'>
                <Select
                    {...menuAboveTable}
                    classNamePrefix="select"
                    className='basic-single w-48'
                    value={event}
                    name="event_name"
                    onChange={(selectedOptions) => handelEventChange(selectedOptions)}
                    options={eventList.map(item => ({
                        value: item.id,
                        label: item.event_name
                    }))}
                    placeholder="Event List"
                    filterOption={(option, inputValue) => {
                        return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                    }}
                />
            </div>
            </>}

            {page !== 'purchase' && <><div className='m-5 max-sm:m-1'>
                <input
                    type="date"
                    className="block p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="from_date"
                    onChange={handleDateChange}
                    value={fromDate}
                />
            </div>
            <div className='m-5 max-sm:m-1'>
                <input
                    type="date"
                    className="block p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="to_date"
                    onChange={handleDateChange}
                    value={toDate}
                />
            </div> </>}
            {page == "requirement" && 
            <>
                <div className='m-5'>
               
                    <Select
                        {...menuAboveTable}
                        classNamePrefix="select"
                        value={session}
                        name="session"
                        placeholder="Session"
                        onChange={(selectedOption, name) => {
                            handleSelectChange(selectedOption, name);
                        }}
                        options={sessionList.map(item => ({
                            value: item.id,
                            label: item.name
                        }))}
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>
                <div className='m-5'>
                    <Select
                        {...menuAboveTable}
                        // isMulti
                        classNamePrefix="select"
                        className='basic-multi-select'
                        value={item}
                        name="item"
                        onChange={(selectedOptions) => handleChangeMultiSelect(selectedOptions, 'item')}
                        options={itemList.map(item => ({
                            value: item.id,
                            label: `${item.item_name} ${item.eng_name ? `(${item.eng_name})` : ''}`
                        }))}
                        placeholder="Item List"
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>
                <div className='m-5'>
                    <Select
                        {...menuAboveTable}
                        classNamePrefix="select"
                        value={requirementStatus}
                        name="requirement_status"
                        className='w-40'
                        onChange={(selectedOption, name) => {
                            handleSelectChange(selectedOption, name);
                        }}
                        options={requirementStatusList.map(item => ({
                            value: item.value,
                            label: item.label
                        }))}
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>
            </>}
            {page == "order" && 
            <>
                <div className='m-5'>
                    <Select
                        {...menuAboveTable}
                        // isMulti
                        classNamePrefix="select"
                        className='basic-multi-select'
                        value={ingredient}
                        name="ingredient"
                        onChange={(selectedOptions) => handleChangeMultiSelect(selectedOptions, 'ingredient')}
                        options={ingredientList.map((item) => ({
                            value: item.id,
                            label: `${item.ingredient} (${item.eng_name})`,
                            eng_name: item.eng_name,
                          }))}
                        placeholder="Ingredient List"
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>
                <div className='m-5'>
                    <Select
                        {...menuAboveTable}
                        classNamePrefix="select"
                        value={orderId}
                        name="order_id"
                        className='w-32'
                        placeholder="Order Id"
                        onChange={(selectedOption, name) => {
                            handleSelectChange(selectedOption, name);
                        }}
                        options={orderIdList.map(item => ({
                            value: item.order_id,
                            label: item.order_id
                        }))}
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>
                <div className='m-5'>
                    <Select
                        {...menuAboveTable}
                        classNamePrefix="select"
                        value={orderStatus}
                        name="order_status"
                        className='w-32'
                        onChange={(selectedOption, name) => {
                            handleSelectChange(selectedOption, name);
                        }}
                        options={orderStatusList.map(item => ({
                            value: item.value,
                            label: item.label
                        }))}
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>
            
            </>}
            {page == "purchase" && 
            <>
                <div className='m-5'>
                    <Select
                        {...menuAboveTable}
                        // isMulti
                        classNamePrefix="select"
                        className='basic-multi-select'
                        value={ingredient}
                        name="ingredient"
                        onChange={(selectedOptions) => handleChangeMultiSelect(selectedOptions, 'ingredient')}
                        options={ingredientList.map((item) => ({
                            value: item.id,
                            label: `${item.ingredient} (${item.eng_name})`,
                            eng_name: item.eng_name,
                          }))}
                        placeholder="Ingredient List"
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>
                
                <div className='m-5'>
                    <Select
                        {...menuAboveTable}
                        classNamePrefix="select"
                        value={purchaseStatus}
                        name="purchase_status"
                        className='w-40'
                        onChange={(selectedOption, name) => {
                            handleSelectChange(selectedOption, name);
                        }}
                        options={purchaseStatusList.map(item => ({
                            value: item.value,
                            label: item.label
                        }))}
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>
            
            </>}
            {page == "receipt" && 
            <>
                <div className='m-5'>
                    <Select
                        {...menuAboveTable}
                        isMulti
                        classNamePrefix="select"
                        className='basic-multi-select'
                        value={ingredient}
                        name="ingredient"
                        onChange={(selectedOptions) => handleChangeMultiSelect(selectedOptions, 'ingredient')}
                        options={ingredientList.map((item) => ({
                            value: item.id,
                            label: `${item.ingredient} (${item.eng_name})`,
                            eng_name: item.eng_name,
                          }))}
                        placeholder="Ingredient List"
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>
                
                <div className='m-5'>
                    <Select
                        {...menuAboveTable}
                        isMulti
                        classNamePrefix="select"
                        value={receiptStatus}
                        name="receipt_status"
                        onChange={(selectedOption, name) => {
                            handleSelectChange(selectedOption, name);
                        }}
                        options={receiptStatusList.map(item => ({
                            value: item.value,
                            label: item.label
                        }))}
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>
            
            </>}
            {page == "issue" && 
            <>
                <div className='m-5'>
               
                    <Select
                        {...menuAboveTable}
                        isMulti
                        classNamePrefix="select"
                        value={session}
                        name="session"
                        onChange={(selectedOption, name) => {
                            handleSelectChange(selectedOption, name);
                        }}
                        options={sessionList.map(item => ({
                            value: item.id,
                            label: item.name
                        }))}
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>
                <div className='m-5'>
                    <Select
                        {...menuAboveTable}
                        isMulti
                        classNamePrefix="select"
                        className='basic-multi-select'
                        value={item}
                        name="item"
                        onChange={(selectedOptions) => handleChangeMultiSelect(selectedOptions, 'item')}
                        options={itemList.map(item => ({
                            value: item.id,
                            label: `${item.item_name} ${item.eng_name ? `(${item.eng_name})` : ''}`
                        }))}
                        placeholder="Item List"
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>

                <div className='m-5'>
                    <Select
                        {...menuAboveTable}
                        isMulti
                        classNamePrefix="select"
                        value={issueStatus}
                        name="issue_status"
                        onChange={(selectedOption, name) => {
                            console.log(selectedOption)
                            handleSelectChange(selectedOption, name);
                        }}
                        options={issueStatusList.map(item => ({
                            value: item.value,
                            label: item.label
                        }))}
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>
            </>}
            {page == "stock_report" && 
            <>
                <div className='m-5'>
               
                    <Select
                        {...menuAboveTable}
                        classNamePrefix="select"
                        value={session}
                        name="session"
                        placeholder="Session"
                        onChange={(selectedOption, name) => {
                            handleSelectChange(selectedOption, name);
                        }}
                        options={sessionList.map(item => ({
                            value: item.id,
                            label: item.name
                        }))}
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>
                <div className='m-5'>
                    <Select
                        {...menuAboveTable}
                        isMulti
                        classNamePrefix="select"
                        className='basic-multi-select'
                        value={ingredient}
                        name="ingredient"
                        onChange={(selectedOptions) => handleChangeMultiSelect(selectedOptions, 'ingredient')}
                        options={ingredientList.map((item) => ({
                            value: item.id,
                            label: `${item.ingredient} (${item.eng_name})`,
                            eng_name: item.eng_name,
                          }))}
                        placeholder="Ingredient List"
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>
            </>}
            <div className='m-5'>
                <button
                    onClick={handleSubmit}
                    className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
                >
                    Submit
                </button>
                {filter && 
                 <button
                 onClick={handleClear}
                 className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
             >
                 Clear
             </button>}
            </div>
        </div>
    );
};

export {VegRequirementFilter};
